/**
 * Model to hold a single TimeZone.
 * Example:
 * {
 *   "id": "America/Chicago",
 *   "abbreviation": "CST",
 *   "offsetMinutes": -360
 * }
 */
export class TimeZone {
    public id: string;
    public abbreviation: string;
    public offsetMinutes: number;

    public clone(): TimeZone {
        const clone: TimeZone = new TimeZone();
        clone.id = this.id;
        clone.abbreviation = this.abbreviation;
        clone.offsetMinutes = this.offsetMinutes;
        return clone;
    }

    public deserialize(json?: ITimeZoneResponse): TimeZone {
        if (json) {
            this.id = json.id;
            this.abbreviation = json.abbreviation;
            this.offsetMinutes = json.offsetMinutes;
        }

        return this;
    }
}

interface ITimeZoneResponse {
    id: string;
    abbreviation: string;
    offsetMinutes: number;
}
